// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UpdateForm_wrapper__SYGeU","createdBy":"UpdateForm_createdBy__64pSi"};